import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parseRegistrationUrlParams } from "@buxus/shared";
import { ExpressRegistrationFlow } from "./registration/ExpressRegistrationFlow";
import { RegistrationFlow } from "./registration/RegistrationFlow";
import "./RegisterScreen.css";

/** Registration entry at `/register` and legacy `/user/register`. */
export function RegisterScreen() {
  const location = useLocation();
  const urlParams = useMemo(() => parseRegistrationUrlParams(location.search), [location.search]);

  if (urlParams.isExpressMode && !urlParams.isExpressReturnMode) {
    return <ExpressRegistrationFlow />;
  }

  return <RegistrationFlow />;
}
